export default __webpack_public_path__ + "static/media/male_liver-01.292a8504.png";